import { Outlet } from "react-router-dom";

/**
 * `app/dashboard/*` had no layout of its own — every page rendered
 * `<DashboardShell>` itself — so this route element only supplies the `Outlet`
 * that the child routes render into.
 */
export function DashboardLayout() {
  return <Outlet />;
}